//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {mapGetters} from "vuex";

export default {
  name: "SectionExcursionEntityContent",
  components: {
    Brochure: () => import('@/components/common/Brochure/index'),
    Section: () => import('@/components/common/Section/index'),
    EntityContent: () => import('@/components/common/EntityContent'),
    ContextAdditions: () => import("@/components/common/ContextAdditions"),
    SocialVideoFrameComponent: () => import('@/components/common/SocialVideoFrameComponent'),
    AudioPlayer: () => import("@/components/common/AudioPlayer"),
    ScheduleCalendar: () => import("@/components/common/ScheduleCalendar"),
    HorizontalEntityCard: () => import('@/components/common/HorizontalEntityCard'),
    Scroller: () => import('@/components/common/Scroller/index'),
    PlaceCard: () => import('@/components/common/PlaceCard'),
    AgencyCard: () => import('@/components/common/AgencyCard/index'),
    GuideCard: () => import('@/components/common/GuideCard/index')
  },
  computed: {
    ...mapGetters({
      activePlayer: 'audio-player/active',
      description: 'excursion/description',
      additions: 'excursion/additions',
      youtube: 'excursion/youtube',
      rutube: 'excursion/rutube',
      vkontakte: 'excursion/vkontakte',
      title: 'excursion/title',
      id: 'excursion/id',
      hasTickets: 'excursion/hasTickets',
      bookingTerms: 'excursion/bookingTerms',
      cancellationTerms: 'excursion/cancellationTerms',
      agency: 'excursion/agency',
      places: 'excursion/places',
      guide: 'excursion/guide',
      audios: 'excursion/audios',
      mediaSource: "excursion/mediaSource",
      protectedAreas: "excursion/protectedAreas",
    })
  },
  created() {
    this.$store.commit('audio-player/setPause')
  }
};
